module.exports = __webpack_public_path__ + "img/wxkf4.46eb50e3.jpg";